import common from './common';
import main from './main';

const th = { common, main };
export default th;
